// Major
import React, {useState} from "react";

// Components
import MKTypography from "components/MKTypography";
import { findCustomFieldValue } from "utils/helpers/findCustomFieldValue";
import EditForm from "../EditForm";
import EditButton from "../EditButton";

// Utils
import usePutTherapistByID from "utils/hooks/usePutTherapistByID";
// Styles
import { StyledStackContainer, StyledProfessionalInfoContainer} from "./index.styles"; 


const ProfessionalInfoEdit = ({userData, handleUpdateUserData}) => {
    const { email, phone, state, city, name, customFields } = userData || [];
    const licenses = findCustomFieldValue("Licenses", customFields);
    const languages = findCustomFieldValue("Languages", customFields);
    const licensedToPracticeIn = findCustomFieldValue("Licensed To Practice In", customFields);
    const [showForm, setShowForm] = useState(false);
    const { updateContactInfo, data, isLoading, isError, error, } = usePutTherapistByID();
    

    const handleSubmit = async (values) => {
        const response = await updateContactInfo(values, userData.id);
        if(response){
            handleUpdateUserData(response);
        }
    }

    // Mapping through list items
    const ListItems = () => {
        const list = []
        const listTitle = []
        if(licensedToPracticeIn){
            list.push(licensedToPracticeIn)
            listTitle.push("Licensed States")
        }
        if(licenses){
            list.push(licenses)
            listTitle.push("Licenses")
        }
        if(languages){
            list.push(languages)
            listTitle.push("Languages")
        }
        return (
            <>
            {list.map((item, index) => (
                <StyledStackContainer key={index} sx={{ margin: "0.5rem" }}>
                    <MKTypography component="p" variant="body2" fontWeight="light">
                        <b>{listTitle[index]}: </b>{item.join(", ")} 
                    </MKTypography>
                </StyledStackContainer>
            ))}
            </>
        )
    }


    const questions = [
        {
            name: "Licensed To Practice In",
            answer: licensedToPracticeIn || [],
            placeholder: "Licensed States",
            type: "select",
            variant: "outlined",
            rows:1,
            multi: true,
            options: [{value: "Alabama", label: "Alabama"}, {value: "Alaska", label: "Alaska"}, {value: "Arizona", label: "Arizona"}, {value: "Arkansas", label: "Arkansas"}, {value: "California", label: "California"}, {value: "Colorado", label: "Colorado"}, {value: "Connecticut", label: "Connecticut"}, {value: "Delaware", label: "Delaware"}, {value: "Florida", label: "Florida"}, {value: "Georgia", label: "Georgia"}, {value: "Hawaii", label: "Hawaii"}, {value: "Idaho", label: "Idaho"}, {value: "Illinois", label: "Illinois"}, {value: "Indiana", label: "Indiana"}, {value: "Iowa", label: "Iowa"}, {value: "Kansas", label: "Kansas"}, {value: "Kentucky", label: "Kentucky"}, {value: "Louisiana", label: "Louisiana"}, {value: "Maine", label: "Maine"}, {value: "Maryland", label: "Maryland"}, {value: "Massachusetts", label: "Massachusetts"}, {value: "Michigan", label: "Michigan"}, {value: "Minnesota", label: "Minnesota"}, {value: "Mississippi", label: "Mississippi"}, {value: "Missouri", label: "Missouri"}, {value: "Montana", label: "Montana"}, {value: "Nebraska", label: "Nebraska"}, {value: "Nevada", label: "Nevada"}, {value: "New Hampshire", label: "New Hampshire"}, {value: "New Jersey", label: "New Jersey"}, {value: "New Mexico", label: "New Mexico"}, {value: "New York", label: "New York"}, {value: "North Carolina", label: "North Carolina"}, {value: "North Dakota", label: "North Dakota"}, {value: "Ohio", label: "Ohio"}, {value: "Oklahoma", label: "Oklahoma"}, {value: "Oregon", label: "Oregon"}, {value: "Pennsylvania", label: "Pennsylvania"}, {value: "Rhode Island", label: "Rhode Island"}, {value: "South Carolina", label: "South Carolina"}, {value: "South Dakota", label:"South Dakota"}, {value: "Tennessee", label: "Tennessee"}, {value: "Texas", label: "Texas"}, {value: "Utah", label: "Utah"}, {value: "Vermont", label: "Vermont"}, {value: "Virginia", label: "Virginia"}, {value: "Washington", label: "Washington"}, {value: "West Virginia", label: "West Virginia"}, {value: "Wisconsin", label: "Wisconsin"}, {value: "Wyoming", label: "Wyoming"}],

        },
        {
            name: "Licenses",
            answer: licenses || [],
            placeholder: "Licenses",
            type: "select",
            variant: "outlined",
            rows: 1,
            multi: true,
            options: [
                { value: "CAT", label: "Licensed Creative Arts Therapist" },
                { value: "Clinical Psychologist", label: "Clinical Psychologist" },
                { value: "LCPC", label: "Licensed Clinical Professional Counselor" },
                { value: "LCSW", label: "Licensed Clinical Social Worker" },
                { value: "LICSW", label: "Licensed Independent Clinical Social Worker" },
                { value: "LMFT", label: "Licensed Marriage and Family Therapist" },
                { value: "LMHC", label: "Licensed Mental Health Counselor" },
                { value: "LMSW", label: "Licensed Master Social Worker" },
                { value: "LPCC", label: "Licensed Professional Clinical Counselor" },
                { value: "LPC", label: "Licensed Professional Counselor" },
                { value: "State of Oregon Facilitator License", label: "State of Oregon Facilitator License" },
              
                { value: "Other", label: "Other" },
              ]
        },
        {
            name: "Languages",
            answer: languages || [],
            placeholder: "Languages",
            type: "select",
            variant: "outlined",
            rows: 1,
            multi: true,
            options: [
                { value: "English", label: "English" },
                { value: "Spanish", label: "Spanish" },
                { value: "Mandarin", label: "Mandarin" },
                { value: "French", label: "French" },
                { value: "German", label: "German" },
                { value: "Japanese", label: "Japanese" },
                { value: "Korean", label: "Korean" },
                { value: "Portuguese", label: "Portuguese" },
                { value: "Russian", label: "Russian" },
                { value: "Italian", label: "Italian" },
                { value: "Arabic", label: "Arabic" },
                { value: "Hindi", label: "Hindi" },
                { value: "Bengali", label: "Bengali" },
                { value: "Urdu", label: "Urdu" },
                { value: "Turkish", label: "Turkish" },
                { value: "Vietnamese", label: "Vietnamese" },
                { value: "Thai", label: "Thai" },
                { value: "Dutch", label: "Dutch" },
                { value: "Greek", label: "Greek" },
                { value: "Swedish", label: "Swedish" },
                { value: "Polish", label: "Polish" },
                { value: "Hebrew", label: "Hebrew" },
                { value: "Other", label: "Other" },
              ],
        }
    ]
    
    return (
        <StyledProfessionalInfoContainer id="therapist-bio-prof-info">
            <MKTypography component="h3" variant="h5" gutterBottom>
                Professional Information <EditButton showForm={showForm} setShowForm={setShowForm}/>
            </MKTypography>
            <ListItems />
            
            {showForm ? <EditForm handleSubmit={handleSubmit} questions={questions}/> : null}
        </StyledProfessionalInfoContainer>
    );
}

export default ProfessionalInfoEdit;